import React from 'react'

const Button = ({
    className = 'h-[48px] ',
    label = "",
    children,
    ...props
}) => {
    return (
        <button
            aria-label={label}
            type='button'
            className={`px-[16px] py-[12px] rounded-[8px] font-[500] tracking-[0.02em] ${className}`}
            {...props}
        >
            {children || label}
        </button>
    )
}

export default Button